export default {
  title: '商户提现',
  steps: {
    one: '选择钱包',
    two: 'google验证器',
    three: '验证密码'
  },
  label: {
    bankId: '提现银行',
    googleDynamicCaptcha: '谷歌验证码',
    payPass: '支付密码',
    walletType: '钱包类型',
    withdrawAmount: '提现金额',
    amountTotal: '总计余额',
    blanceAmount: '剩余余额'
  },
  rules: {
    bankId: {
      required: '提现银行id必须选择'
    },
    googleDynamicCaptcha: {
      required: '谷歌验证码不能为空',
      type: '谷歌验证码必须为数字',
      max: '谷歌验证码为6位数字'
    },
    payPass: {
      required: '支付密码不能为空'
    },
    walletType: {
      required: '钱包类型必须选择'
    },
    withdrawAmount: {
      required: '提现金额不能为空',
      type: '提现金额必须为数字',
      min: '提现金额必须大于1000',
      max: '提现金额不能大于余额'
    }
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh/merchantdeposit.js